
import _ from 'lodash';
import {setDefaults} from "@/router/helper";
// 工厂生产
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)

//这个也是工厂生产，是后续开发版本
const clothesProduceOrderList= () => import('@/views/factoryProductionAfter/clothesProduceOrderList.vue');
const produceStatusOrderList= () => import('@/views/factoryProductionAfter/produceStatusOrderList.vue');
const clothesProduceContain= () => import('@/views/factoryProductionAfter/clothesProduceContain.vue');
const clothesProduceRecord= () => import('@/views/factoryProductionAfter/clothesProduceRecord.vue');
const clothesReworkRecord= () => import('@/views/factoryProductionAfter/clothesReworkRecord.vue');
const factoryAttendanceRecord= () => import('@/views/factoryProductionAfter/factoryAttendanceRecord.vue');

const orderClothesProduceCensus= () => import('@/views/factoryProductionAfter/containPages/orderClothesProduceCensus.vue');

const clothesProduceGroupCensus= () => import('@/views/factoryProductionAfter/clothesProduceGroupCensus.vue');
const orderClothesPackProcess= () => import('@/views/factoryProductionAfter/orderClothesPackProcess.vue');
const clothesPackPlansAndCaseInOrder= () => import('@/views/factoryProductionAfter/clothesPackPlansAndCaseInOrder.vue');
const clothesPackPlan= () => import('@/views/factoryProductionAfter/clothesPackPlanDir/clothesPackPlan.vue');
const clothesProgressReports= () => import('@/views/factoryProductionAfter/clothesProgressReports.vue');
const processTaskTeamCount= () => import('@/views/factoryProduction/processTaskCount/processTaskTeamCount.vue');


const routes = [
  {
    path: 'clothesProduceOrderList',
    meta: {
      title: '生产统计(旧)',
    },
    component: clothesProduceOrderList,
  },{
    path:'producStatusOrderList',
    meta:{
      title:'生产统计(新)'
    },
    component: produceStatusOrderList,
  },
  {
    path: 'clothesProduceContain',
    meta: {
      title: '录入记录',
    },
    component: clothesProduceContain,
  },
  {
    path: 'clothesProduceRecord/:id',
    meta: {
      title: '生产/报废详情',
    },
    component: clothesProduceRecord,
  },
  {
    path: 'clothesReworkRecord/:id',
    meta: {
      title: '返工详情',
    },
    component: clothesReworkRecord,
  },
  {
    path: 'factoryAttendanceRecord/:id',
    meta: {
      title: '出勤记录',
    },
    component: factoryAttendanceRecord,
  },{
    path:'orderClothesProduceCensus/:orderId',
    meta:{
      title:'订单产出详情',
    },
    component:orderClothesProduceCensus
  },{
    path:'clothesProduceGroupCensus',
    meta:{
      title:'小组产量统计',
    },
    component:clothesProduceGroupCensus
  },{
    path:'orderClothesPackProcess',
    meta: {
      title: '订单成衣装箱进度',
    },
    component: orderClothesPackProcess,
  },{
    path:'clothesPackPlansAndCaseInOrder/:orderId',
    meta:{
      title: '包装进度和装箱',
    },
    component: clothesPackPlansAndCaseInOrder,
  },{
    path: 'clothesPackPlan/:id',
    meta: {
      title:'装箱计划详情',
    },
    component: clothesPackPlan
  },{
    path:'progressReportsAll',
    meta:{
      title:'进度报告总览',
    },
    component: clothesProgressReports,
  },{
    path:'processTaskTeamCount',
    meta:{
      title:'工人工艺计产',
    },
    component: processTaskTeamCount,
  }
];



export default setDefaults(routes);
